import DOMPurify from 'dompurify';

// CalOne calendar fields (title / location / description) can carry simple HTML
// — most often a MazeMap room link wrapped in an <a> tag, exactly as the Toast
// UI fullview renders it. Sanitize before rendering so those links work without
// allowing arbitrary/unsafe markup.
const ALLOWED_TAGS = ['a', 'b', 'strong', 'i', 'em', 'u', 'br', 'span'];
const ALLOWED_ATTR = ['href', 'target', 'rel', 'title'];

export function sanitizeCalendarHtml(html: string | null | undefined): string {
  if (!html) return '';
  return DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR });
}

// Convenience for React's dangerouslySetInnerHTML.
export function calendarHtml(html: string | null | undefined): { __html: string } {
  return { __html: sanitizeCalendarHtml(html) };
}

// Event descriptions are rich text from the editor (headings, lists, links,
// basic formatting). Allow that markup but strip scripts, event handlers,
// iframes, etc. DOMPurify removes on* attributes and javascript: URLs by
// default, so stored XSS via a crafted description is neutralised.
const RICH_TAGS = [
  'a', 'b', 'strong', 'i', 'em', 'u', 's', 'strike', 'br', 'span', 'div',
  'p', 'ul', 'ol', 'li', 'blockquote', 'code', 'pre',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr',
];
const RICH_ATTR = ['href', 'target', 'rel', 'title', 'class'];

export function sanitizeRichHtml(html: string | null | undefined): string {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: RICH_TAGS,
    ALLOWED_ATTR: RICH_ATTR,
  });
}

// Convenience for React's dangerouslySetInnerHTML on rich descriptions.
export function richHtml(html: string | null | undefined): { __html: string } {
  return { __html: sanitizeRichHtml(html) };
}
